// extracted by mini-css-extract-plugin
export default {"illustration":"R3HrWnvIDWAv8VrzyiUd"};